'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useRouter } from '@/i18n/navigation';

/**
 * This component reloads the application when an update from Strapi is reported. This is useful for the sidebar preview
 * in case of Growth or EE plans.
 *
 * I did not have access to either of these at the time of writing, so I am unable to validate if this works correctly.
 *
 * It does not impact the static preview in Community version of Strapi, as user has to leave the preview in order to change content.
 */
function StrapiPreviewListener() {
  const $ = _c(3);
  const router = useRouter();
  let t0;
  if ($[0] !== router) {
    t0 = () => {
      const handleMessage = message => {
        if (message?.data?.type === "strapiUpdate") {
          router.refresh();
        }
      };
      window.addEventListener("message", handleMessage);
      return () => {
        window.removeEventListener("message", handleMessage);
      };
    };
    $[0] = router;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useEffect(t0, t1);
  return null;
}
export default StrapiPreviewListener;